







































import {Component, Vue, Ref, Prop} from "vue-property-decorator";
import SlidingPanel from '../_sliding-panel/sliding-panel.vue';
import { SidebarState } from '../../store';
import findElementById from '@/lib/find-element-by-id';
import { namespace } from 'vuex-class';
const sidebarState = namespace('SidebarState');

@Component({
    name: "SettingsPanel",
    components: { SlidingPanel },
})
export default class SettingsPanel extends Vue {
    @Prop({ required: false }) public username: string;
    @Prop({ required: false, default: false }) public scopelessMode: boolean;
    @sidebarState.Getter isSettingsPanelOpen: boolean;
    @sidebarState.Action closeSettings: () => void;
    @sidebarState.Action toggleSettings: () => void;

    @Ref('SettingsPanel') settingsPanel: Vue;

    public onClickOutside(e: Event) {

        if (!this.isSettingsPanelOpen) return;
        const eventTarget = e.target as HTMLElement;
        // skip - webcomponent shell.
        // another listener handling webcomponent shadow dom
        if (eventTarget.shadowRoot) return;

        const thisComponent = this.settingsPanel.$el;
        const btnToggle = findElementById({
            elementId: 'setting-menu-toggle',
            shadowRootToSearch: eventTarget?.shadowRoot,
            webComponentTagToSearch: 'axc-powerbar'});

        // skip - click hits the toggle button
        if (btnToggle?.contains(eventTarget)) return;

        // skip - click hits within this component
        if (thisComponent?.contains(eventTarget)) return;

        this.closeSettings();
    }

    public get changePasswordUrl(): string {
        return `/my/change-password?returnUrl=${encodeURIComponent(document?.location?.href||'')}`;
    }

    public mounted() {
        document.querySelector('axc-powerbar')?.shadowRoot?.addEventListener('click', this.onClickOutside);
        window.addEventListener('click', this.onClickOutside);
        window.addEventListener('scroll', this.closeSettings);
    }
    public unmounted() {
        document.querySelector('axc-powerbar')?.shadowRoot?.removeEventListener('click', this.onClickOutside);
        window.removeEventListener('click', this.onClickOutside);
        window.removeEventListener('scroll', this.closeSettings);
    }

    public beforeCreate() { SidebarState.register?.(this.$store); }
    public destroyed() { SidebarState.unregister?.(this.$store); }
}
